var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLniLniBills1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2293_8691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87819 7.16046H6.97755C7.24678 7.16046 7.49358 6.9361 7.49358 6.66687C7.49358 6.39764 7.26922 6.17328 6.97755 6.17328H6.79806C6.79806 5.90405 6.57371 5.67969 6.30447 5.67969C6.03524 5.67969 5.81088 5.90405 5.81088 6.17328C5.24999 6.21815 4.80127 6.6893 4.80127 7.2502C4.80127 7.85597 5.29486 8.34956 5.90063 8.34956H6.41665C6.46153 8.34956 6.5064 8.39443 6.5064 8.4393C6.5064 8.48417 6.46153 8.52905 6.41665 8.52905H5.3173C5.04806 8.52905 4.82371 8.75341 4.82371 9.02264C4.82371 9.29187 5.04806 9.51623 5.3173 9.51623H5.83332C5.83332 9.78546 6.05768 10.0098 6.32691 10.0098C6.59614 10.0098 6.8205 9.78546 6.8205 9.51623V9.42648C7.22435 9.26943 7.49358 8.86559 7.49358 8.41687C7.49358 7.8111 6.99999 7.31751 6.39422 7.31751H5.87819C5.83332 7.31751 5.78845 7.27264 5.78845 7.22776C5.78845 7.18289 5.83332 7.16046 5.87819 7.16046Z",
    fill: "#996B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8814 3.72656H1.39103C0.628205 3.72656 0 4.35477 0 5.11759V10.5022C0 11.265 0.628205 11.8932 1.39103 11.8932H10.8814C11.6442 11.8932 12.2724 11.265 12.2724 10.5022V5.11759C12.2949 4.35477 11.6667 3.72656 10.8814 3.72656ZM11.2853 10.5022C11.2853 10.7266 11.1058 10.906 10.8814 10.906H1.39103C1.16667 10.906 0.987179 10.7266 0.987179 10.5022V5.11759C0.987179 4.89323 1.16667 4.71374 1.39103 4.71374H10.8814C11.1058 4.71374 11.2853 4.89323 11.2853 5.11759V10.5022Z",
    fill: "#996B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6089 2H3.07367C2.80444 2 2.58008 2.22436 2.58008 2.49359C2.58008 2.76282 2.80444 2.98718 3.07367 2.98718H12.6089C12.8333 2.98718 13.0128 3.16667 13.0128 3.39103V8.79808C13.0128 9.06731 13.2371 9.29167 13.5064 9.29167C13.7756 9.29167 14 9.06731 14 8.79808V3.41346C14 2.62821 13.3717 2 12.6089 2Z",
    fill: "#996B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36547 7.33984H2.53534C2.26611 7.33984 2.04175 7.5642 2.04175 7.83343C2.04175 8.10266 2.26611 8.32702 2.53534 8.32702H3.36547C3.6347 8.32702 3.85906 8.10266 3.85906 7.83343C3.85906 7.5642 3.6347 7.33984 3.36547 7.33984Z",
    fill: "#996B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96166 7.33984H9.13153C8.8623 7.33984 8.63794 7.5642 8.63794 7.83343C8.63794 8.10266 8.8623 8.32702 9.13153 8.32702H9.96166C10.2309 8.32702 10.4552 8.10266 10.4552 7.83343C10.4552 7.5642 10.2533 7.33984 9.96166 7.33984Z",
    fill: "#996B68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_8691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLniLniBills1);
export default __webpack_public_path__ + "static/media/lni_lni-bills-1.c59d2a7079c5307df650606cd2bd498b.svg";
export { ForwardRef as ReactComponent };